import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const getReportData = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/report/data`, params)
  return response.data
}

export const getReportList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/report/list`, params)
  return response.data
}

export const getPartnerReportList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/report/partnerList`, params)
  return response.data
}

export const queryCreditReport = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/credit/submitFullQuery`, params)
  return response.data
}

export const getWithBizNo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/credit/getCreditWithBizNo`, params)
  return response.data
}

export const ocrIdCard = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/credit/ocrIdCard`, params)
  return response.data
}

export const authCustomer = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/credit/auth`, params)
  return response.data
}
